import { trackEvent } from "@/utils/analytics";

interface AppStoreBadgesProps {
  className?: string;
}

const AppStoreBadges = ({ className = "" }: AppStoreBadgesProps) => {
  const handleClick = (store: string) => {
    trackEvent('app_store_click', { store });
  };

  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      <a
        href="https://apps.apple.com/es/app/the-flip-app/id1641134087?l=en-GB"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => handleClick('apple')}
        className="opacity-80 hover:opacity-100 transition-opacity"
      >
        <img src="/images/app-store-badge.svg" alt="Download on the App Store" className="h-10 w-auto object-contain" width={135} height={40} loading="lazy" decoding="async" />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=app.theflip"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => handleClick('google')}
        className="opacity-80 hover:opacity-100 transition-opacity"
      >
        <img src="/images/google-play-badge.svg" alt="Get it on Google Play" className="h-10 w-auto object-contain" width={135} height={40} loading="lazy" decoding="async" />
      </a>
    </div>
  );
};

export default AppStoreBadges;
